export default __webpack_public_path__ + "static/media/incapacitation.5653d0ee.pdf";